import type { Scene } from '@babylonjs/core/scene';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { CreatePlane } from '@babylonjs/core/Meshes/Builders/planeBuilder';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math.color';

export class SandalView {
  private readonly mesh:Mesh;
  private readonly material:StandardMaterial;
  private readonly texture:Texture;
  private time=0;
  constructor(scene:Scene){
    this.mesh=CreatePlane('sandal-boomerang',{size:1.1},scene);
    // Foreground combat layer: the sandal remains legible while crossing a
    // fighter's billboard rather than disappearing behind the hit sprite.
    this.mesh.renderingGroupId=1;
    this.mesh.billboardMode=Mesh.BILLBOARDMODE_ALL;this.mesh.isPickable=false;
    this.texture=new Texture('/proto2d/gandhi/sandal.png',scene,true,true,Texture.NEAREST_SAMPLINGMODE);this.texture.hasAlpha=true;
    this.material=new StandardMaterial('sandal-boomerang',scene);this.material.diffuseTexture=this.texture;
    this.material.useAlphaFromDiffuseTexture=true;this.material.disableLighting=true;this.material.emissiveColor=Color3.White();this.material.backFaceCulling=false;
    this.mesh.material=this.material;
  }
  update(x:number,y:number,z:number,_fx:number,_fz:number,dt:number){this.time+=dt;this.mesh.position.set(x,y,z);this.mesh.rotation.z=this.time*18;}
  dispose(){this.mesh.dispose();this.material.dispose();this.texture.dispose();}
}
